module.exports = __webpack_public_path__ + "static/media/BwModelicaSS02-Regular.a2f46451.otf";